import { tv } from 'tailwind-variants';
import { STICKY_POSITION } from '../constants.esm.js';

const StickyElementStyles = tv({
    slots: {
        container: `
      iris:sticky
      iris:z-[1000]
      iris:bg-(--comp-color-background-sticky-bar-default)
      iris:[box-shadow:0_var(--sem-elevation-elevation-layer-01-y,0)_var(--sem-elevation-elevation-layer-01-blur,0)_var(--sem-elevation-elevation-layer-01-spread,1px)_var(--sem-color-shadow-default,rgba(0,0,0,0.05)),0_var(--sem-elevation-elevation-layer-02-y,2px)_var(--sem-elevation-elevation-layer-02-blur,2px)_var(--sem-elevation-elevation-layer-02-spread,0)_var(--sem-color-shadow-default,rgba(0,0,0,0.05)),0_var(--sem-elevation-elevation-layer-03-y,4px)_var(--sem-elevation-elevation-layer-03-blur,4px)_var(--sem-elevation-elevation-layer-04-spread,-2px)_var(--sem-color-shadow-default,rgba(0,0,0,0.05))]
    `,
    },
    variants: {
        position: {
            top: {
                container: "iris:top-0 iris:right-0 iris:left-0",
            },
            bottom: {
                container: "iris:right-0 iris:bottom-0 iris:left-0",
            },
        },
        visible: {
            true: {
                container: "iris:pointer-events-auto",
            },
            false: {
                container: "iris:pointer-events-none",
            },
        },
    },
    compoundVariants: [
        // Entry animations
        {
            position: STICKY_POSITION.TOP,
            visible: true,
            class: {
                container: "iris:[animation:stickyElementTopIn_var(--comp-motion-duration-sticky-bar-entry)_var(--comp-motion-easing-sticky-bar)_forwards]",
            },
        },
        {
            position: STICKY_POSITION.BOTTOM,
            visible: true,
            class: {
                container: "iris:[animation:stickyElementBottomIn_var(--comp-motion-duration-sticky-bar-entry)_var(--comp-motion-easing-sticky-bar)_forwards]",
            },
        },
        // Exit animations
        {
            position: STICKY_POSITION.TOP,
            visible: false,
            class: {
                container: "iris:[animation:stickyElementTopOut_var(--comp-motion-duration-sticky-bar-exit)_var(--comp-motion-easing-sticky-bar)_forwards]",
            },
        },
        {
            position: STICKY_POSITION.BOTTOM,
            visible: false,
            class: {
                container: "iris:[animation:stickyElementBottomOut_var(--comp-motion-duration-sticky-bar-exit)_var(--comp-motion-easing-sticky-bar)_forwards]",
            },
        },
    ],
});

export { StickyElementStyles as default };
